module.exports = __webpack_public_path__ + "img/round.0aff4eaf.svg";